var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.2812C14.2259 13.2812 15.625 11.8821 15.625 10.1562C15.625 8.43036 14.2259 7.03125 12.5 7.03125C10.7741 7.03125 9.375 8.43036 9.375 10.1562C9.375 11.8821 10.7741 13.2812 12.5 13.2812Z",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 10.1562C20.3125 17.1875 12.5 22.6562 12.5 22.6562C12.5 22.6562 4.6875 17.1875 4.6875 10.1562C4.6875 8.08425 5.5106 6.09711 6.97573 4.63198C8.44086 3.16685 10.428 2.34375 12.5 2.34375C14.572 2.34375 16.5591 3.16685 18.0243 4.63198C19.4894 6.09711 20.3125 8.08425 20.3125 10.1562V10.1562Z",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/MapPin.3e7a8c2167455552830befd247ca84e7.svg";
export { ForwardRef as ReactComponent };